










































































import { Component, Prop } from 'vue-property-decorator';
import Form from "@/layouts/Form";
import AdministratorEntityModule from "@/store/administrators/entity";
import { AdministratorCard } from '@/types/models/administrators';

import InputBase from '@/components/input/Input.vue';
import MultiSelect from '@/components/multiselect/MultiSelectEntity.vue';
import CheckboxBase from "@/components/checkbox/Checkbox.vue";
import InputPassword from '@/components/input/InputPassword.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import { MultiSelectValue } from '@/components/multiselect/types';
import { SelectItem } from '@/components/select/types';
import { RoleEnum } from '@/store/user';

type FormErrors = Record<string, string>

interface FormValues {
    name: string,
    patronymic: string,
    surname: string,
    phone: string,
    email: string,
    clinics: MultiSelectValue[],
    role: SelectItem | null,
    password: string,
    passwordConfirm: string,
    is_active: boolean,
}

@Component({
    components: {
        InputBase,
        MultiSelect,
        CheckboxBase,
        InputPassword,
        SelectCustom,
    }
})
export default class AdministratorForm extends Form {
    @Prop() formValues?: AdministratorCard; // initial values
    @Prop({ default: () => ({}) }) errors!: Partial<FormErrors>;
    @Prop({ default: false }) readonly!: boolean;

    values: FormValues = {
        name: '',
        patronymic: '',
        surname: '',
        email: '',
        phone: '',
        is_active: false,
        role: null,
        clinics: [],
        password: '',
        passwordConfirm: '',
    };

    get model() {
        return AdministratorEntityModule.model;
    }

    get adminRole() {
        return RoleEnum.ROLE_ADMIN;
    }

    initFormValues() {
        if (!this.formValues) {
            return;
        }

        const role = this.model.role.list.find(role => role.value === (this.formValues?.roleTitle as string)) as SelectItem || null;

        this.values = {
            ...this.values,
            name: this.formValues.name || '',
            patronymic: this.formValues.patronymic || '',
            surname: this.formValues.surname || '',
            email: this.formValues.email || '',
            phone: this.formValues.phone || '',
            is_active: this.formValues.is_active || false,
            role: role,
            clinics: (this.formValues.clinics ?? []).map((clinic) => ({
                id: clinic.id,
                value: clinic.title,
            })),
            password: this.formValues.password || '',
        }
    }

    updateIsActive(data: {name: string; id: string; bool: boolean}) {
        this.values.is_active = data.bool;
    }

    public triggerSave() {
        this.update();   
    }

    async update() {
        this.$emit("submit", this.values);
    }

    mounted() {
        AdministratorEntityModule.SET_DISABLED_BY_TYPE({
            type: 'role', disabled: this.$route.name === 'administrators_edit' ? true : false,
        });
        this.initFormValues();
    }
}
